import { useDispatch, useSelector } from 'react-redux';
import RadioButtonsGroup from '../../RadioButtonsGroup';
import GenericBarChart from '../../Charts/GenericBarChart';
import { PROPERTY_ADDED_CATEGORIES } from '../../constants';
import {
  setAddedProperties,
  setPerformanceModals,
} from '@/store/slices/components/dashboard/DashboardSlice';
import PerformanceCard from '../PerformanceCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceAddedPropertiesCard } from '@/store/slices/components/dashboard/service';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '../../constants/track';

export default function AddedProperties() {
  const dispatch = useDispatch();
  const {
    loading,
    hasFetched,
    value,
    variation,
    percentage_status,
    icon,
    options,
    selectedOption,
  } = useSelector((state) => state.DashboardSlice.addedProperties);
  const selectedOptionLabels = options[selectedOption].labels;
  const selectedOptionDatasets = options[selectedOption].datasets;
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const track = useTrackPerformanceTabCard();

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceAddedPropertiesCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleClickRadio = (item) => {
    dispatch(setAddedProperties({ key: 'selectedOption', value: item.id }));
    track.addedProperties(TRACK_ELEMENT.RADIO_BUTTON_OPTION);
  };

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'addedProperties',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  const allowedOptions = [
    { id: PROPERTY_ADDED_CATEGORIES.TYPE, text: Trans(translations, 'Type') },
    {
      id: PROPERTY_ADDED_CATEGORIES.OPERATION,
      text: Trans(translations, 'Operation'),
    },
  ];

  return (
    <PerformanceCard
      ref={ref}
      loading={loading || isStale}
      id="added-properties"
    >
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'AddedProperties')}
      </PerformanceCard.Header>
      <PerformanceCard.Summary
        value={value}
        tendency={variation}
        icon={icon}
        percentageStatus={percentage_status}
      >
        <RadioButtonsGroup
          allowedOptions={allowedOptions}
          selectedOption={selectedOption}
          onClickRadio={handleClickRadio}
        />
      </PerformanceCard.Summary>

      <PerformanceCard.Content>
        <GenericBarChart
          labels={selectedOptionLabels}
          datasets={selectedOptionDatasets}
          stacked={false}
        />
      </PerformanceCard.Content>
    </PerformanceCard>
  );
}
